import React from "react";

import BackGround from "components/common/BackGround";
import Gnb from "components/common/Gnb";
import Footer from "components/common/Footer";
import Guides from "components/guide/Guides";

export default function Guide() {
    return (
        <BackGround>
            <Gnb />
            <Guides />
            <Footer />
        </BackGround>
    );
}